module.exports = __webpack_public_path__ + "static/assets/fb516154e603365f64d22b89fc08b8f8.png";